<template>
  <div v-if="this.errors_array.length > 0">
    <!-- MODO ALERTA (BARRA DE NOTIFICAÇÃO ESTILO TOAST) -->
    <div v-if="type === 'alert'" class="alert-toast-wrapper">
      <b-alert
        show
        variant="warning"
        class="border-0 shadow-lg rounded-lg d-flex align-items-center py-2 px-4 mb-0"
        dismissible
      >
        <div class="flex-grow-1">
          <h6 class="font-weight-bold mb-1">
            <i class="fa fa-exclamation-circle mr-2 font-medium-4"></i>
            Atenção!
          </h6>
          <ul class="mb-0 pl-0 list-group">
            <li class="list-group-item bg-transparent border-0 p-0" v-for="(item, index) in errors_array" :key="index" v-html="item.erro"></li>
          </ul>
        </div>
      </b-alert>
    </div>

    <!-- MODO POPOVER (ÍCONE FLUTUANTE) -->
    <div class="float-left pr-1" v-else>
      <b-btn class="badge badge-warning" @click="showPopover = !showPopover" id="popoverButton-sync" v-b-tooltip.hover.left="'Clique aqui para ver os erros encontrados'" variant="warning"><i class="fa fa-exclamation-triangle fa-2x"></i></b-btn>

      <b-popover :show.sync="showPopover" target="popoverButton-sync" title="Erros Encontrados" data-html="true" placement="leftbottom">
        <table class="table" id="mais">
          <tbody>
          <tr class="bg-gray-light" style="display: table-row;" v-for="(item, index) in this.errors_array" :key="index">
            <td v-html="item.erro"></td>
          </tr>
          </tbody>
        </table>
      </b-popover>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    errors_array: Array,
    type: {
      type: String,
      default: 'popover'
    }
  },
  data() {
    return {
      showPopover: false,
    }
  },
  watch: {
    errors_array: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.type === 'alert') {
          this.playErrorSound();
        }
      }
    }
  },
  methods: {
    playErrorSound() {
      const audio = new Audio('/audio/erro_old.mp3');
      audio.play().catch(e => console.log('Erro ao reproduzir som:', e));
    }
  }
}
</script>

<style scoped>
.alert-toast-wrapper {
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 9999;
  max-width: 450px;
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
